export default class extends ApplicationController {
    connect() {
        this.element.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", (event) => {
                const target = event.target
                target.style.color = '#ee1742'
            })
        })
    }
}